/**
 * BikePathLegend - Легенда типов велодорожек
 *
 * Мигрирована на новую систему легенд (Этап 3)
 * Использует LegendRenderer с типом COLORED_ITEMS и иконкой LINE
 */

import { t } from '@lingui/macro';
import { LegendRenderer } from '../../LegendRenderer';
import { BIKE_PATH_LEGEND } from '../../../constants/legends';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';

const BikePathLegendComponent = () => (
    <LegendRenderer config={BIKE_PATH_LEGEND} />
);

export const BikePathLegend = withDisplayedLayersCheck(BikePathLegendComponent, t`Велодорожки`);
